export type getUser = {
  active: boolean
  email: string
  company: string
  role: string
  last_login: string
  createdDate: string
  id: number
  name: string
}

export const GET_USER_STARTED = 'GET_USER_STARTED'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_ERROR = 'GET_USER_ERROR'

export const POST_USER_LOGOUT = 'POST_USER_LOGOUT'

export interface userLogOut {
  type: typeof POST_USER_LOGOUT
}

export interface userError {
  type: typeof GET_USER_ERROR
}
export interface userStart {
  type: typeof GET_USER_STARTED
}
export interface userSuccess {
  type: typeof GET_USER_SUCCESS
  payload: getUser
}

export type ActionTypes = userError | userSuccess | userStart | userLogOut

export type DispatchType = (args: ActionTypes) => ActionTypes
